import styled from 'styled-components';

export const ReduxView = styled.div`
    position: absolute;
    top: 10%;
    left: 10%;
    width: 320px;
    height: 500px;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 0;
    z-index: 1000;
    display: flex;
    flex-direction: column;
`;

export const ReduxViewHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background-color: #f5f5f5;
    border-bottom: 1px solid #ddd;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    cursor: grab;
    width: 100%;
    &:active {
        cursor: grabbing;
    }
`;

export const HeaderTitle = styled.div`
    font-weight: bold;
    font-size: 14px;
    color: #333;
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const HeaderControls = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const MinimizeButton = styled.button`
    border-radius: 20%;
    border-color:grey;
    background: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
    
    &:hover {
        background-color: #ddd;
    }
`;

export const MoveIcon = styled.div`
    font-size: 16px;
    color: #777;
`;

export const ReduxViewContent = styled.div`
    flex: 1;
    overflow-y: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 16px;
`;

export const Reducers = styled.div`
    margin-bottom: 16px;
    width: 100%;
`;

export const Label = styled.div`
    font-weight: bold;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    width: 100%;
`;

export const Reduce = styled.div`
    margin-left: 16px;
    margin-top: 8px;
    padding-left: 8px;
    border-left: 2px solid #eee;
    width: 100%;
    box-sizing: border-box;
`;

export const State = styled.div`
    margin-left: 16px;
    margin-top: 4px;
    padding-left: 8px;
    width: 100%;
    box-sizing: border-box;
`;

export const Text = styled.span`
    font-size: 14px;
    color: #333;
    font-family: monospace;
    white-space: pre-wrap;
    word-break: break-word;
`;

export const CollapsibleButton = styled.button`
    background: none;
    border: none;
    color: #007bff;
    cursor: pointer;
    font-size: 14px;
    margin-left: 8px;

    &:hover {
        text-decoration: underline;
    }
`;

export const RefreshButton = styled.button`
    background: none;
    border: none;
    color: #007bff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
    margin-left: 8px;
    border-radius: 3px;
    
    &:hover {
        background-color: #e6f2ff;
    }
`;
